import { render } from "./StudentColumnsSelect.vue?vue&type=template&id=e3765c8c&scoped=true&ts=true"
import script from "./StudentColumnsSelect.vue?vue&type=script&lang=ts"
export * from "./StudentColumnsSelect.vue?vue&type=script&lang=ts"

import "./StudentColumnsSelect.vue?vue&type=style&index=0&id=e3765c8c&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\y-tosa.LOCALPSC\\repo\\seto-solan\\apps\\admin-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e3765c8c"]])

export default __exports__